<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="declutterReport.status === 'recorded'"
          v-can="'declutterreport.update'"
          :command="startDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-s-promotion" /> Véglegesítés
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutterReport.status === 'done'"
          v-can="'declutterreport.view'"
          :command="printDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Nyomtatás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutterReport.status === 'recorded'"
          v-can="'declutterreport.view'"
          :command="previewDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-view"/> Előnézet
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutterReport.status === 'recorded'"
          v-can="'declutterreport.update'"
          :command="updateDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutterReport.status === 'recorded'"
          v-can="'declutterreport.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['declutterReport'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteDeclutter() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('declutterReport/delete', this.declutterReport.id);
          this.$store.dispatch('declutterReport/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateDeclutter() {
        this.$router.push('/processes/declutters/reports/update/' + this.declutterReport.id);
      },
      async startDeclutter() {
        this.buttonLoader = true;
        try {
          await axios.post(`api/declutter-reports/close/${this.declutterReport.id}`);
          this.$store.dispatch('declutterReport/fetchAll');
        } catch (e) {}
        this.buttonLoader = false;
      },
      async printDeclutter() {
        this.buttonLoader = true;
        try {
          const response = await axios.get(`api/receipts/declutterReport/${this.declutterReport.id}`, {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf'
            },
          });

          const newBlob = new Blob([response], { type: 'application/pdf' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          const data = window.URL.createObjectURL(newBlob);
          window.open(data);
        } catch (e) {
          console.log(e)
        }
        this.buttonLoader = false;
      },
      async previewDeclutter() {
        this.buttonLoader = true;
        try {
          const response = await axios.get(`api/declutters/reports/preview/${this.declutterReport.id}`, {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf'
            },
          });

          const newBlob = new Blob([response], { type: 'application/pdf' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          const data = window.URL.createObjectURL(newBlob);
          window.open(data);
        } catch (e) {
          console.log(e)
        }
        this.buttonLoader = false;
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteDeclutter();
        })
        .catch(() => {
          this.$router.replace('/processes/declutters/reports');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/declutterReports/' + this.declutterReport.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'declutterReport_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
